<template>
  <div>
    <div class="search-bar">
      <div style="display:flex">
        <el-input
          class="search_input_cla"
          clearable
          @clear="getDeviceList"
          :placeholder="this.$t('common.searchValue')"
          v-model.trim="searchText"
          @keyup.enter.native="getDeviceList"
        >
          <el-button
            @click="getDeviceList"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
      <div class="deviceList_info_cla">
        <div class="info_item1_cla">
          <i class="icon_cla1"></i>
          <label>{{ $t('device.totalDevice') + '：' }}</label>
          <span>{{ devNum }}</span>
        </div>

        <div class="info_item2_cla">
          <i class="icon_cla2"></i>
          <label>{{ $t('device.online') + '：' }}</label>
          <span>{{ onlineNumber }}</span>
        </div>

        <div class="info_item3_cla">
          <i class="icon_cla3"></i>
          <label>{{ $t('device.offLine') + '：' }}</label>
          <span>{{ offlineNumber }}</span>
        </div>
      </div>
    </div>
    <zk-table
      ref="table"
      :columns="columnData"
      :data="tableData"
      @rowClick="rowClick"
      :stripe="false"
    ></zk-table>
  </div>
</template>

<script>
import { findBindDevice } from '@/services/deviceApi.js'
export default {
  data() {
    let _self = this
    return {
      devNum: 0,
      offlineNumber: 0,
      onlineNumber: 0,
      tableData: [],
      searchText: '',
      columnData: [
        {
          label: this.$t('device.sn'),
          prop: 'devSn'
        },
        {
          label: this.$t('device.alias'),
          prop: 'devAlias',
          render: (h, params) => {
            return h('span', {}, _self.isEmpty(params.row.devAlias))
          }
        },
        {
          label: this.$t('device.devType'),
          prop: 'devType'
        },
        {
          label: this.$t('device.firmwave'),
          prop: 'fwVersion'
        },
        {
          label: this.$t('device.equipmentStatus'),
          render: (h, params) => {
            let isEnable = params.row.enable
            let a = null
            if (isEnable === false) {
              a = h(
                'div',
                {
                  class: {
                    'device-status-bar-cla': true
                  }
                },
                [
                  h('div', {
                    class: {
                      'device-disbale-cla': true
                    }
                  }),
                  h('span', {}, [this.$t('device.disbaleDevice')])
                ]
              )
            } else if (isEnable === true) {
              if (params.row.devStatus === 1) {
                a = h(
                  'div',
                  {
                    class: {
                      'device-status-bar-cla': true
                    }
                  },
                  [
                    h('div', {
                      class: {
                        'device-online-cla': true
                      }
                    }),
                    h('span', {}, [this.$t('device.online')])
                  ]
                )
              } else {
                a = h(
                  'div',
                  {
                    class: {
                      'device-status-bar-cla': true
                    }
                  },
                  [
                    h('div', {
                      class: {
                        'device-offline-cla': true
                      }
                    }),
                    h('span', {}, [this.$t('device.offLine')])
                  ]
                )
              }
            }
            return a
          }
        }
      ]
    }
  },
  props: {
    employeeId: {
      type: '',
      default: ''
    }
  },
  watch: {
    employeeId(newValue) {
      if (newValue) {
        this.getDeviceList()
      }
    }
  },
  mounted() {
    this.getDeviceList()
  },
  methods: {
    rowClick() {},
    getDeviceList() {
      if (!this.employeeId) {
        return false
      }
      findBindDevice({
        searchText: this.searchText,
        employeeId: this.employeeId
      })
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            this.devNum = data.payload.devNum
            this.offlineNumber = data.payload.offlineNumber
            this.onlineNumber = data.payload.onlineNumber
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e.message)
        })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
/deep/ .device-status-bar-cla {
  display: flex;
  align-items: center;
}

.deviceList_info_cla {
  display: flex;
  .info_item_cla {
    padding: 0px 15px;
    height: 20px;
    line-height: 20px;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    label {
      white-space: nowrap;
      font-size: 14px;
    }
    span {
      font-size: 18px;
    }
  }

  .icon_base {
    height: 18px;
    width: 18px;
    margin-right: 8px;
  }
  .info_item1_cla {
    .info_item_cla;
    .icon_cla1 {
      background: center/cover url('~~@/assets/new/image/totalDevice1.svg')
        no-repeat;
      .icon_base();
    }
    span {
      color: @themeColor;
    }
  }

  .info_item2_cla {
    .info_item_cla;
    .icon_cla2 {
      background: center/cover url('~~@/assets/new/image/onlineCount1.svg')
        no-repeat;
      .icon_base();
    }
    span {
      color: @statusSuccess;
    }
  }

  .info_item3_cla {
    .info_item_cla;
    .icon_cla3 {
      background: center/cover url('~~@/assets/new/image/disableCount1.svg')
        no-repeat;
      .icon_base();
    }
    span {
      color: @statusWarning;
    }
  }
  .info_item4_cla {
    .info_item_cla;
    .icon_cla4 {
      background: center/cover url('~~@/assets/new/image/offLineCount1.svg')
        no-repeat;
      .icon_base();
    }
    span {
      color: @ststusFailed;
    }
  }
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/employeeDetail/deviceList.vue